import moment from 'moment'

// Formats API timestamps stored as UTC. The .NET side serialises them with
// Kind=Unspecified, so the wire value has no 'Z' and `new Date()` would read it as
// local - a silent no-op. Append 'Z' when there is no designator, then format.
//
// NOT every timestamp qualifies: some CSP Renewals fields are still written as
// AWST wall-clock (renewalsDisabledAt), and those are correct under a bare parse.
// Sending one through here shows it eight hours early. If you normalise one of
// those to UTC, move its formatter here in the same change.

const hasTimezone = (iso) => {
  // Look only at the time portion to avoid false positives on the
  // YYYY-MM-DD hyphens. The split() is forgiving of inputs that
  // skip seconds or fractional seconds.
  const tIdx = iso.indexOf('T')
  if (tIdx === -1) return false
  const tail = iso.slice(tIdx + 1)
  return tail.endsWith('Z') || /[+\-]\d{2}:?\d{2}$/.test(tail)
}

// Exported for callers that need their own toLocaleString options rather
// than one of the presets below.
export const parseIso = (iso) => {
  if (!iso) return null
  const normalised = hasTimezone(iso) ? iso : `${iso}Z`
  const d = new Date(normalised)
  return isNaN(d.getTime()) ? null : d
}

// Long form: "01 Jun 2026, 8:37 am"
export const formatDateTime = (iso) => {
  const d = parseIso(iso)
  return d ? moment(d).format('DD MMM YYYY, h:mm a') : '—'
}

// Short form: defers entirely to the browser's locale ("1/06/2026,
// 4:37:00 pm" in en-AU). Activity Log uses this so the column stays
// compact even on a packed table.
export const formatLocal = (iso) => {
  const d = parseIso(iso)
  if (!d) return '—'
  return d.toLocaleString()
}

// Date-only "01 Jun 2026". Same UTC-normalisation applies because
// a UTC timestamp late in the day can roll over to the next date
// once converted to Perth/AWST.
export const formatDate = (iso) => {
  const d = parseIso(iso)
  return d ? moment(d).format('DD MMM YYYY') : '—'
}
